import SFetch from '@app/utils/sfetch'

export default {
  getAnnotations({ ownerId, ownerType }) {
    const url = Silverfin.Routes.pdf_annotations_path({
      firm_id: Silverfin.currentFirmId,
      company_id: Silverfin.currentCompanyId,
      owner_type: ownerType,
      owner_id: ownerId,
    })
    return SFetch.json(url)
  },

  updateAnnotation({ id, xfdfString }) {
    const data = { xfdfString }

    const url = Silverfin.Routes.pdf_annotation_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      id
    )

    return SFetch.json(url, {
      method: 'PATCH',
      body: { pdf_annotation: data },
    })
  },
}
